import * as types from "./types";

const mutations = {
    [types.LOADING_NOTIFICATION](state, value) {
        state.loading = value;
    },
    [types.LOADING_PUSHNOTIFICATION](state, value) {
        state.loading = value;
    },
    [types.GET_NOTIFICATION](state, notification) {
        state.notification = notification;
    },
    [types.GET_PUSHNOTIFICATION](state, pushnotification) {
        state.pushnotification = pushnotification;
    },
    [types.PUT_PUSHNOTIFICATION](state, pushnotification) {
        // Find the index of the notification in the itemList array
        const pushnotificationIndex = state.pushnotification.itemList.findIndex(
            (x) => x.id === pushnotification.id
        );
    
        // If the notification exists, update it
        if (pushnotificationIndex !== -1) {
            state.pushnotification.itemList[pushnotificationIndex] = pushnotification;
        } else {
            // If it doesn't exist, optionally add it to the list (optional behavior)
            state.pushnotification.itemList.push(pushnotification);
        }
    },
};

export default mutations;